import { jsx as x } from "react/jsx-runtime";
import { inputStyles as m } from "../Input/Input.js";
import { cn as y } from "@deputy-ai/common";
import * as p from "react";
const V = p.forwardRef(
  (f, g) => {
    const {
      className: S,
      type: v = "number",
      ring: N = !0,
      onChange: a,
      onValueChange: n,
      min: u,
      max: i,
      value: r,
      step: b = "any",
      ...d
    } = f;
    function o(t) {
      return t !== void 0 ? String(t) : "";
    }
    const [l, s] = p.useState(o(r));
    p.useEffect(() => {
      o(r) !== l && s(o(r));
    }, [r]);
    const w = (t) => {
      const c = t.target.value;
      if (c === "") {
        s("");
        return;
      }
      let e = Number(c);
      u !== void 0 && (e = Math.max(u, e)), i !== void 0 && (e = Math.min(i, e)), s(String(e)), a == null || a({
        ...t,
        target: {
          // eslint-disable-next-line @typescript-eslint/no-misused-spread
          ...t.target,
          value: String(e)
        }
      }), n == null || n(e);
    };
    return /* @__PURE__ */ x(
      "input",
      {
        ref: g,
        className: y(
          m.wrapper,
          m.input,
          N && m.ring,
          S
        ),
        type: v,
        step: b,
        max: i,
        min: u,
        value: l,
        onChange: w,
        ...d
      }
    );
  }
);
V.displayName = "InputNumber";
export {
  V as InputNumber
};
